/**
 * 全球指数顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"
import { ChartType } from "../../shared/utils"

export function GlobalBasicInfo() {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
            <div>
              <p className="stock-value">{store.chart_mouse_move_data ? quote_chart[quote_item_name.最新价](store.chart_mouse_move_data.newPrice, store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.最新价](store.StockDetail).element}</p>
              <p>
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌幅](store.chart_mouse_move_data.zdf, store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.涨跌幅](store.StockDetail).element}
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌额](store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.涨跌额](store.StockDetail).element}
              </p>
            </div>
            <div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>今开</span>
                      {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>今开</span>
                      {single_quote[quote_item_name.今开](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {single_quote[quote_item_name.最高](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {single_quote[quote_item_name.最低](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
              <div className="row">
                {store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>总量</span>
                      {quote_chart[quote_item_name.总手](store.chart_mouse_move_data.zongshou).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {quote_chart[quote_item_name.成交额](store.chart_mouse_move_data.amount).element}
                    </p>
                    <p>
                      <span>振幅</span>
                      {quote_chart[quote_item_name.振幅](store.chart_mouse_move_data.amplitude).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>总量</span>
                      {single_quote[quote_item_name.总手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {single_quote[quote_item_name.成交额](store.StockDetail).element}
                    </p>
                    <p>
                      <span>振幅</span>
                      {single_quote[quote_item_name.振幅](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-p">
            {store.chartType == ChartType.日K && store.chart_mouse_move_data ? (
              <>
                <p>
                  {quote_chart[quote_item_name.日K时间](store.chart_mouse_move_data.time).element}
                  <span></span>
                </p>
                <p></p>
                <p></p>
              </>
            ) : (
              <>
                <p>
                  <span>昨收</span>
                  {single_quote[quote_item_name.昨收](store.StockDetail).element}
                </p>
                <p></p>
                <p></p>
                <p></p>
              </>
            )}
          </div>
        </div>
      )}
    </Observer>
  )
}
